import script from "./DocsApiComp.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsApiComp.vue?vue&type=script&setup=true&lang=js"

import "./DocsApiComp.vue?vue&type=style&index=0&id=30627b0b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30627b0b"]])

export default __exports__